import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { hash } from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class MathsReportingTimeOnTaskRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const product: LegacyProductMs = 'maths'
    const scopedStudents = scopedData.students

    let statsScope: SchoolScope | StudentsScope = { scope: 'school', ids: [uiScope.id] }
    if (uiScope.scope !== 'school') {
      statsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }
    }

    const stats = await this.makeStatsRequests(product, statsScope, period)

    return { uiScope, students: scopedStudents, ...stats }
  }

  makeStatsRequests = async (
    product: LegacyProductMs,
    scope: SchoolScope | StudentsScope,
    period: NormalizedInterval,
  ) => {
    const { studentEvents } = this
    return hash({
      timeOnTaskHistory: studentEvents.timeOnTaskHistory(product, scope, period),
      timeOnTaskUsage: studentEvents.timeOnTaskUsage(product, scope, period),
    })
  }
}
